/* Auftrag 15 (B1, 07.10.2026) – Produktgalerie: Bild 2 ff. erst bei Bedarf laden.
   snippets/responsive-image.liquid gibt Folien ab 2 mit Platzhalter und data-kz-srcset / data-kz-src aus (Schalter kz_galerie_spaeter).
   Geladen wird, sobald eine Folie aktiv wird (Wischen, Pfeile, Vorschaubild, Variantenwechsel – auch nach dem Neuaufbau durch
   variants.js), beim ersten Berühren der Galerie die Nachbarfolien, beim Antippen eines Vorschaubilds dessen Folie, vor dem Zoom alle.
   Beobachtet wird der feste Rahmen #product-gallery-<Abschnitt>, weil variants.js dessen Inhalt ersetzt. */
(function () {
  'use strict';
  var SEL = 'img[data-kz-srcset]';
  var CFG = document.currentScript || document.getElementById('kz-galerie-js');

  function laden(img) {
    var srcset = img.getAttribute('data-kz-srcset');
    if (!srcset) return;
    img.setAttribute('srcset', srcset);
    img.setAttribute('src', img.getAttribute('data-kz-src'));
    img.removeAttribute('data-kz-srcset');
    img.removeAttribute('data-kz-src');
    img.classList.remove('kz-spaeter');
  }
  function folie(el) {
    if (el && el.querySelectorAll) Array.prototype.forEach.call(el.querySelectorAll(SEL), laden);
  }
  function aktive(rahmen) {
    return rahmen.querySelectorAll('.product-image-main .swiper-slide-active, .product-style-2-main-img .swiper-slide-active');
  }
  function nachbarn(rahmen) {
    Array.prototype.forEach.call(aktive(rahmen), function (a) {
      folie(a);
      folie(a.nextElementSibling);
      folie(a.previousElementSibling);
    });
  }
  function einrichten(rahmen) {
    if (rahmen.__kzGalerie) return;
    rahmen.__kzGalerie = true;
    new MutationObserver(function (aenderungen) {
      for (var i = 0; i < aenderungen.length; i++) {
        var m = aenderungen[i];
        if (m.type === 'attributes') {
          if (m.target.classList && m.target.classList.contains('swiper-slide-active')) folie(m.target);
        } else {
          Array.prototype.forEach.call(aktive(rahmen), folie);
        }
      }
    }).observe(rahmen, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    var zuerst = function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var vorschau = t.closest('.product-image-thumb .swiper-slide');
      if (vorschau) {
        var nr = vorschau.getAttribute('data-index');
        folie(rahmen.querySelector('.product-image-main .swiper-slide[data-index="' + nr + '"]'));
        return;
      }
      if (t.closest('.product-image-main, .product-style-2-main-img')) nachbarn(rahmen);
    };
    rahmen.addEventListener('touchstart', zuerst, { passive: true });
    rahmen.addEventListener('pointerdown', zuerst, { passive: true });
    rahmen.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-gallery-photoswipe__trigger')) folie(rahmen);
    }, true);
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-gallery[id^="product-gallery-"]'), function (r) {
      if (r.querySelector(SEL)) einrichten(r);
      Array.prototype.forEach.call(aktive(r), folie);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);

  /* Auftrag 15 (B2): Zoom (Photoswipe) erst beim ersten Öffnen laden – CSS, Bibliothek, Theme-Skript (product-photoswipe.js bindet
     sich per jQuery-Delegation an den Zoom-Knopf). Danach den ursprünglichen Klick wiederholen. Schalter kz_bedarf_laden. */
  if (!CFG || CFG.hasAttribute('data-pswp-aus')) return;
  var laedt = null;
  function skript(src) {
    return new Promise(function (ok, nein) {
      var s = document.createElement('script'); s.src = src; s.onload = ok; s.onerror = nein; document.head.appendChild(s);
    });
  }
  function css(href) {
    return new Promise(function (ok) {
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; l.onload = ok; l.onerror = ok; document.head.appendChild(l);
    });
  }
  function zoomLaden() {
    if (!laedt) {
      laedt = Promise.all([
        css(CFG.getAttribute('data-pswp-css')),
        skript(CFG.getAttribute('data-pswp-lib')).then(function () { return skript(CFG.getAttribute('data-pswp-js')); })
      ]);
    }
    return laedt;
  }
  function ziel(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    return t.closest('.product-gallery-photoswipe__trigger') || (!window.ZOOM && t.closest('.product-image-main .product-media.media-image > img'));
  }
  document.addEventListener('pointerdown', function (e) { if (!window.__kzPswp && ziel(e)) zoomLaden(); }, true);
  document.addEventListener('click', function (e) {
    if (window.__kzPswp) return;
    var t = ziel(e);
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var r = t.closest('.product-gallery[id^="product-gallery-"]');
    if (r) folie(r);
    zoomLaden().then(function () {
      window.__kzPswp = true;
      setTimeout(function () { t.click(); }, 0);
    }, function () { window.__kzPswp = true; });
  }, true);
})();
